module.exports = __webpack_public_path__ + "img/ci.61d09df6.svg";